import { IAnyType, Instance, SnapshotIn, SnapshotOut, types } from "mobx-state-tree"
import { RoomModel } from "../Room"
import { TripCollaboratorModel } from "./tripCollaborator"
import { PortModel } from "./port"
import { ITrip } from "@cruisen/contract"

export const TripModel = types.model("Trip").props({
  id: types.identifier,
  name: types.string,
  ownerId: types.string,
  chosenTripSearchResultId: types.optional(types.string, ""),
  inviteLink: types.optional(types.string, ""),
  collaboratorIds: types.array(types.string),
  collaborators: types.array(TripCollaboratorModel),
  originPorts: types.array(PortModel),
  originPortGroups: types.array(PortModel),
  destinationPorts: types.array(PortModel),
  destinationRegions: types.array(PortModel),
  months: types.array(types.integer),
  rooms: types.array(RoomModel),
  isNavigatorLoading: types.optional(types.boolean, false),
  navigatorCruiseRecommendations: types.optional(types.array(types.string), []),
  twilioConversationSid: types.optional(types.string, ""),
  tags: types.array(types.string),
  twilioConversationMessagesCounter: types.optional(types.integer, 0),
  twilioConversationLastMessageDate: types.optional(types.integer, 0),
  created: types.optional(types.integer, () => Date.now()),
  updated: types.optional(types.integer, () => Date.now()),
  updatedBy: types.optional(types.string, ""),
  lastActive: types.optional(types.integer, () => Date.now()),
  viewsCounter: types.optional(types.integer, 0),
  hasGoneToCheckout: types.optional(types.integer, 0),
  bookingEnabled: types.optional(types.boolean, false),
  loyaltyProgramEnabled: types.optional(types.boolean, false),
  cruiseSearchPreferences: types.optional(types.frozen(), {}),
} as { [P in keyof ITrip]: IAnyType })

export type Trip = Instance<typeof TripModel>
export type TripSnapshotOut = SnapshotOut<typeof TripModel>
export type TripSnapshotIn = SnapshotIn<typeof TripModel>
